import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';

import styles from 'iss/styles/Input.styl';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';

export function BootstrapInput(props) {
  const inputProps = R.pick(['placeholder', 'onChange', 'id', 'readOnly', 'disabled', 'size', 'maxLength', 'className', 'min', 'max', 'step'], props);
  inputProps.type = R.defaultTo('text', props.type);
  inputProps.value = R.defaultTo('', props.value);

  if (inputProps.type === "file") {
    inputProps.value = undefined;
  }

  return <BootstrapFormGroup {...props}>
    <input className="form-control" aria-describedby={props.id+"-help-text"} {...inputProps} />
    {props.error ? <span className="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span> : null}
    {props.showCounter ? <span className={styles.counterText}>{length(props.value) + " / " + inputProps.maxLength}</span> : null}
  </BootstrapFormGroup>;
}
// TODO Counter is not inside the form group container div because of "float: right" -> counter span's bottom margin doesn't affect the group container's margin. How to fix this?

BootstrapInput.propTypes = {
  id: PropTypes.string.isRequired,
};

export default BootstrapInput;

function length(value) {
  return value == null ? 0 : value.length;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/Input.jsx